import { JSONSchema6 } from "json-schema";

export interface FxJsonSchema extends JSONSchema6 {
    schemaPath?: string;
}

export const  a = 1;



// WEBPACK FOOTER //
// ./src/models/jsonschema.ts